import { createUseStyles } from 'react-jss'

export const style = {
  select: {
    marginBottom: 10
  },
  container: {
    '& > * + *': {
      marginTop: 10
    }
  },
  formLabel: {
    composes: 'form-element-label-medium'
  },
  labels: {
    marginTop: 5
  },
  labelEdit: {
    display: 'flex',
    alignItems: 'center'
  },
  grabber: {
    padding: '8px 8px 8px 0'
  },
  field: {
    flex: 1,
    padding: 2
  },
  categoryToggleSwitch: {
    display: 'flex'
  },
  hide: {
    flex: '0 0 40px',
    paddingLeft: 6
  }
}

export const useStyles = createUseStyles(style)
